const configuration = {
  /**
   * This configuration file is parsed by the ghs-config-plugin during the webpack build process. There are multiple levels of configuration
   * based upon the brand and environment.
   *
   * Lodash merge is used to build the final config for the environment/brand. Config sections override from bottom to top of the merge function
   * below.
   *
   * merge(
   *   {},
   *   config.all.common,
   *   config.all[options.brand].common,
   *   config.all[options.brand][options.platform],
   *   config[options.environment].common,
   *   config[options.environment][options.brand]
   * )
   *
   * For example if a apiUrl value is set on all.common, all.grubhub, prod.common and prod.grubhub, the value from prod.grubhub is used when the environment
   * is prod and the brand is grubhub.
   */
  all: {
    common: {
      scheme: 'ghs',
      applePayBrandName: 'Grubhub',
      navigationDelay: 125,
      contentfulCdnUrl: 'https://cdn.contentful.com',
      contentfulStaticUrl: 'https://preview.contentful.com',
      contentfulEnvironment: 'development',
      contentfulHybridSpaceId: 'p96xu0myf1w3',
      contentfulFeatureToggleSpaceId: 'xb9bg8gz5y0c',
      contentfulStaticSpaceId: 'yhm0akg1t95o',
      contentfulAccessToken: 'ntzON9hCtogjZ9ncgpXA_jR4HAKSrz5XfwCfjUJIxs0',
      contentfulFeatureToggleAccessToken:
        'WUKfzP1lKSlkuR-ipvbYH8yBjkUuwUjWEw8iboHmkwQ',
      contentfulStaticWebAccessToken:
        '989868351c081e1b7c4a3776246e2bfec1f6959b2cc8717aea85de9615410f44',
      contentfulPrivacyRoot: '3FbAQNKRxKeRdp3nCa7iZ',
      contentfulGoldDaysRoot: '5swbHNenBWDn5arNW9dQGs',
      contentfulGoldDaysSpaceId: 'p96xu0myf1w3',
      contentfulForceUseBackup: false,
      clickstreamApp: 'umami',
      clickstreamAppVersion: 'dashi',
      privacyRootUrl: '/modules/privacy/page',
      privacyRootPath: '/modules/privacy/page',
      privacyPagePath: '/:contentSlug',
      subscriptionsRootUrl: '/modules/subscriptions', // Is it confusing that some routes don't use this root route?
      pxCookieName: '_px2',
      pxCookieHeaderToJJ: 'perimeter-x',
      pxBlockRequestIdHeader: 'c7617800-1f83-11e7-aee6-4bc8eed8c64b',
      robots: 'noindex, nofollow',
      staticContentUrl: '/eat/static-espresso-hybrid?contentOnly=1',
      subscriptionPurchaseBackgroundImage:
        'https://res.cloudinary.com/grubhub-assets/image/upload/v1575476193/subscriptions/Mobile_Banner.svg',
      inAuthConfig: {
        inAuthSiteKey: '9ac852f03293779b',
        inAuthCollectorUrl: 'www.cdn-net.com',
        inAuthCollectorFlags: '30359547',
        inAuthBehavioralFraudDetection: [3, 100, 15],
      },
      zopimButtonColor: '#0070EB',
      datadog: {
        appId: '57fc97ff-18b0-4497-90e8-e20e56bfe4ee',
        clientToken: 'pub7d8a4e2b197e9b9df3079e0da2bf2430',
        service: 'espresso-hybrid',
      },
    },
    web: {
      privacyRootUrl: '/help/privacy',
      privacyRootPath: '/help/privacy',
      subscriptionPurchaseBackgroundImage:
        'https://res.cloudinary.com/grubhub-assets/image/upload/v1575476193/subscriptions/Desktop_Banner.svg',
    },
    grubhub: {
      common: {
        contentfulFooterContentId: '52RkDorUW4OAW8msE0iUoM',
        subscriptionInfoPageContentId: '4NfqlwXy6PKwUhDFh8SlTV',
        subscriptionPartnerErrorPageContentId: '4fDW1E3e7wgjNcRzsIBSOi',
        primaryColor: '#FF8000',
        friendBuyWidgetId: 'b2K-obS',
        logoUrl:
          'https://res.cloudinary.com/grubhub-assets/image/upload/v1553883528/static-homepage/logo-full-primary.svg',
        zopimLogoUrl:
          'https://res.cloudinary.com/grubhub-assets/image/upload/v1626378102/Citrus-assets/GH%20Branded/Web%20%28Umami%29/Logos/Top%20Navigation//logo-alt-small.svg',
        subscriptions: {
          citiGiveawayId: 'faa17225-dfd1-4e18-8b3a-166d64b82d80',
          metaImageUrl:
            'https://res.cloudinary.com/grubhub-marketing/image/upload/v1582752111/HERMES/2020/DINER/PRO/PRO-20191025-Grubhub%2BMembership-Launch/PHASE%201/Brand%20Assets/GH_Image.png',
          productFullName: 'Grubhub+',
          productShortName: 'GH+',
          cmsContentIds: [
            '5S0ktRefCrCfpNTrHaMDZ3',
            '9woWlHY8E5cGGlsOdlvKa',
            '69IqtkW18TkhN09yGCXdB5',
          ],
          logoUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1603220547/subscriptions/Web%20-%20GH%2B%20Assets/Updated%20GH%2B%20Icons%20/GH-logo-light.svg',
          cancellationIllustrationUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1577663368/subscriptions/subscriptionCancelation_illustration_h3jlzd.svg',
          infoSearchIllustrationUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/f_auto,fl_lossy/v1574444804/subscriptions/PhoneBadge-2_3x.png',
          mainImageUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1574365621/subscriptions/interstitial_asset_v2.svg',
          flagImageUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1577660727/subscriptions/flag_oyyevx.svg',
          flagBigImageUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1577662196/subscriptions/GH-flag-menumodal_hskndd.svg',
          subscriptionCancellationCardUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1602784005/subscriptions/Cashback/GH%2B/GH__Cashfan_stars.svg',
          subscriptionAccountLogo:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1595873371/subscriptions/Web%20-%20GH%2B%20Assets/Lyft%20integration/DC-3020%20Account%20Management%20Attribution/mweb_logo_GH.svg',
          subscriptionInfoLogo:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1595873371/subscriptions/Web%20-%20GH%2B%20Assets/Lyft%20integration/DC-3020%20Account%20Management%20Attribution/desktop_logo_GH.svg',
          subscriptionInfoHeroImg:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1602782862/subscriptions/GH_Circle_Graphic.svg',
          subscriptionPurchaseHeaderLogoSmall:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1603998604/subscriptions/Plus%20Page%20%28Standalone%29/Purchase%20Page/Grubhub%2B%20Purchase%20Page/grubhub_-logo-small-mobile_svg.svg',
          subscriptionPurchaseHeaderLogoLarge:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1603998602/subscriptions/Plus%20Page%20%28Standalone%29/Purchase%20Page/Grubhub%2B%20Purchase%20Page/grubhub_-logo-big-desktop_svg.svg',
          subscriptionInelligibleImage:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1606238734/subscriptions/Plus%20Page%20%28Standalone%29/Ineligible%20and%20cancel%20page/gh-clock_svg.svg',
          subscriptionCancellationImage:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1606238734/subscriptions/Plus%20Page%20%28Standalone%29/Ineligible%20and%20cancel%20page/gh-broken-plate_svg.svg',
          subscriptionCardBackgroundImageDesktop:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1620053144/subscriptions/Web%20-%20GH%2B%20Assets/data%20sharing%20page/desktop.svg',
          subscriptionCardBackgroundImageMobile:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1620053144/subscriptions/Web%20-%20GH%2B%20Assets/data%20sharing%20page/mobile.svg',
        },
      },
      ios: {
        friendBuyWidgetId: 'b2K-obS',
      },
      android: {
        friendBuyWidgetId: 'b2K-obR',
      },
    },
    seamless: {
      common: {
        contentfulFooterContentId: '5tCa6aNHZCmsCYY2yqwWIg',
        subscriptionInfoPageContentId: '2QqBqvhHkeSWnmVNnLRE7U',
        subscriptionPartnerErrorPageContentId: '5X80JbieGOqHvUFL6FgD49',
        primaryColor: '#FF8000',
        friendBuyWidgetId: 'de1-och',
        logoUrl:
          'https://res.cloudinary.com/grubhub-assets/image/upload/v1576531623/Seamlesslogonodimensions.svg',
        zopimLogoUrl:
          'https://res.cloudinary.com/grubhub-assets/image/upload/v1626378102/Citrus-assets/GH%20Branded/Web%20%28Umami%29/Logos/Top%20Navigation//Seamlesslogonodimensions.svg',
        subscriptions: {
          metaImageUrl:
            'https://res.cloudinary.com/grubhub-marketing/image/upload/v1582752310/HERMES/2020/DINER/PRO/PRO-20191025-Grubhub%2BMembership-Launch/PHASE%201/Brand%20Assets/SL_Image.png',
          productFullName: 'Seamless+',
          productShortName: 'S+',
          cmsContentIds: ['75VEOhHKu8szr74XWREqCk', '56aMcGXc70H69F1T8bODSb'],
          logoUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1603220547/subscriptions/Web%20-%20GH%2B%20Assets/Updated%20GH%2B%20Icons%20/SL-logo-light.svg',
          cancellationIllustrationUrl:
            'https://media-cdn.grubhub.com/image/upload/v1573081251/subscriptions/SL/cancelation%20assets/subscriptionCancelation_illustration.svg',
          infoSearchIllustrationUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1578418164/subscriptions/S_PhoneBadge.svg',
          mainImageUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1577742658/subscriptions/S_Stand_alone.svg',
          flagImageUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1577663084/subscriptions/s_flag_ihsory.svg',
          flagBigImageUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1577663084/subscriptions/S-flag-menumodal_hgkdlv.svg',
          subscriptionCancellationCardUrl:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1602784122/subscriptions/Cashback/SL%2B/SL__Cashfan_Stars.svg',
          subscriptionAccountLogo:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1595873373/subscriptions/Web%20-%20GH%2B%20Assets/Lyft%20integration/DC-3020%20Account%20Management%20Attribution/mweb_logo_SL.svg',
          subscriptionInfoLogo:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1595873371/subscriptions/Web%20-%20GH%2B%20Assets/Lyft%20integration/DC-3020%20Account%20Management%20Attribution/desktop_logo_SL.svg',
          subscriptionInfoHeroImg:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1603301539/subscriptions/SL__Circle_Graphic.svg',
          subscriptionPurchaseHeaderLogoSmall:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1603998604/subscriptions/Plus%20Page%20%28Standalone%29/Purchase%20Page/Grubhub%2B%20Purchase%20Page/grubhub_-logo-small-mobile_svg.svg',
          subscriptionPurchaseHeaderLogoLarge:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1603998602/subscriptions/Plus%20Page%20%28Standalone%29/Purchase%20Page/Grubhub%2B%20Purchase%20Page/grubhub_-logo-big-desktop_svg.svg',
          subscriptionInelligibleImage:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1606238734/subscriptions/Plus%20Page%20%28Standalone%29/Ineligible%20and%20cancel%20page/seamless-clock_svg.svg',
          subscriptionCancellationImage:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1606238734/subscriptions/Plus%20Page%20%28Standalone%29/Ineligible%20and%20cancel%20page/seamless-broken-plate_svg.svg',
          subscriptionCardBackgroundImageDesktop:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1620053144/subscriptions/Web%20-%20GH%2B%20Assets/data%20sharing%20page/desktop.svg',
          subscriptionCardBackgroundImageMobile:
            'https://res.cloudinary.com/grubhub-assets/image/upload/v1620053144/subscriptions/Web%20-%20GH%2B%20Assets/data%20sharing%20page/mobile.svg',
        },
      },
      ios: {
        friendBuyWidgetId: 'de1-och',
      },
      android: {
        friendBuyWidgetId: 'de1-oci',
      },
    },
  },
  development: {
    common: {
      applePayMerchantId: 'merchant.com.grubhub.diner.sandbox',
      jjApiUrl: 'https://api-order-taking-pp.grubhub.com',
      itJJApiUrl: 'https://api-pp-internal-tools.grubhub.com',
      ccIframeUrl: 'https://cc-pp.grubhub.com/ghs-payments.js',
      clickstreamV2PostUrl: 'https://api-pp.grubhub.com',
      assets: 'https://assets-pp.grubhub.com',
      zopimId: 'bc531127-991c-4477-9ec6-35390e439158',
      zopimAvailabilityUrl:
        'https://api-pp-internal-tools.grubhub.com/carereporting/chat/available',
      tapingoTicketsUrl:
        'https://api-pp-internal-tools-us-east-1.grubhub.com/care-metrics/tapingo/tickets',
      tealiumEnvironment: 'dev',
      brazeOptions: {
        enableLogging: false,
        minimumIntervalBetweenTriggerActionsInSeconds: 10,
        sessionTimeoutInSeconds: 30,
        baseUrl: 'https://sdk.iad-01.braze.com/api/v3',
      },
      sensorId: 'uRyvZ3Vg',
    },
    grubhub: {
      common: {
        umamiUrl: 'https://pp.grubhub.com',
        ghCuisinesPrefix: 'https://pp.grubhub.com/ghcuisines/',
        clientId:
          'tu7P94aGXt99gk6s3e8ffVeRFDFXsWAKKiAcFeCYuQiuf7CE3xNqiAQbgY8axThN',
        friendBuyId: 'site-2500bb38-host',
        googleNonConvertingTrackingId: 'UA-309051-83',
        googleAnalyticsTrackingId: 'UA-309051-51',
        googleAnalyticsTrackerName: 'teal_grubhublabs_UniversalstagingStandard',
        googleOptimizeContainerId: 'GTM-WZ7VL9Z',
        brazeId: '34821d0d-2bf2-49fb-9903-95dde46a0d04',
        captchaUrl: 'https://localhost:4001/captcha/verify?',
      },
      ios: {
        googleNonConvertingTrackingId: 'UA-309051-83',
        googleAnalyticsTrackingId: 'UA-309051-51',
        googleAnalyticsTrackerName: 'teal_grubhublabs_UniversalstagingStandard',
        googleOptimizeContainerId: 'GTM-WZ7VL9Z',
      },
      web: {
        clientId: 'beta_UmWlpstzQSFmocLy3h1UieYcVST',
      },
    },
    seamless: {
      common: {
        umamiUrl: 'https://pp.seamless.com',
        ghCuisinesPrefix: 'https://pp.seamless.com/ghcuisines/',
        clientId:
          'rDsQ74nhfDjpsk7Jbq99WWL473pA2aEGX3aBJr4U9QK3JdpCVW8qFK2Zd5DhDCVG',
        googleNonConvertingTrackingId: 'UA-229205-52',
        googleAnalyticsTrackingId: 'UA-229205-42',
        googleAnalyticsTrackerName:
          'teal_seamlesslabs_UniversalstagingStandard',
        googleOptimizeContainerId: 'GTM-W3VGLRQ',
        friendBuyId: 'site-177d0ef0-www.seamless.com',
        brazeId: 'c8ca1ae4-6f71-445f-b6d5-3fe8d694d73a',
        captchaUrl: 'https://localhost:4002/captcha/verify?',
      },
      web: {
        clientId: 'beta_seamless_ayNyuFxxVQYefSAhFYCryvXBPQc',
      },
    },
  },
  preproduction: {
    common: {
      applePayMerchantId: 'merchant.com.grubhub.diner.sandbox',
      jjApiUrl: 'https://api-order-taking-pp.grubhub.com',
      itJJApiUrl: 'https://api-pp-internal-tools.grubhub.com',
      ccIframeUrl: 'https://cc-pp.grubhub.com/ghs-payments.js',
      clickstreamV2PostUrl: 'https://api-pp.grubhub.com',
      assets: 'https://assets-pp.grubhub.com',
      zopimId: 'bc531127-991c-4477-9ec6-35390e439158',
      zopimAvailabilityUrl:
        'https://api-pp-internal-tools.grubhub.com/carereporting/chat/available',
      tapingoTicketsUrl:
        'https://api-pp-internal-tools.grubhub.com/care-metrics/tapingo/tickets',
      sentry: {
        dsn: 'https://fdca46de26b74a6bb0fe0fbd362f7a10@sentry.io/1525572',
        sampleRate: 1.0,
      },
      tealiumEnvironment: 'dev',
      brazeOptions: {
        enableLogging: true,
        minimumIntervalBetweenTriggerActionsInSeconds: 10,
        sessionTimeoutInSeconds: 600,
        baseUrl: 'https://sdk.iad-01.braze.com/api/v3',
      },
      sensorId: 'uRyvZ3Vg',
    },
    grubhub: {
      common: {
        umamiUrl: 'https://pp.grubhub.com',
        ghCuisinesPrefix: 'https://pp.grubhub.com/ghcuisines/',
        clientId:
          'tu7P94aGXt99gk6s3e8ffVeRFDFXsWAKKiAcFeCYuQiuf7CE3xNqiAQbgY8axThN',
        googleNonConvertingTrackingId: 'UA-309051-83',
        googleAnalyticsTrackingId: 'UA-309051-51',
        googleAnalyticsTrackerName: 'teal_grubhublabs_UniversalstagingStandard',
        googleOptimizeContainerId: 'GTM-WZ7VL9Z',
        friendBuyId: 'site-2500bb38-host',
        brazeId: '34821d0d-2bf2-49fb-9903-95dde46a0d04',
        captchaUrl: 'https://pp.grubhub.com/captcha/verify?',
      },
      web: {
        clientId: 'beta_UmWlpstzQSFmocLy3h1UieYcVST',
      },
    },
    seamless: {
      common: {
        umamiUrl: 'https://pp.seamless.com',
        ghCuisinesPrefix: 'https://pp.seamless.com/ghcuisines/',
        clientId:
          'rDsQ74nhfDjpsk7Jbq99WWL473pA2aEGX3aBJr4U9QK3JdpCVW8qFK2Zd5DhDCVG',
        googleNonConvertingTrackingId: 'UA-229205-52',
        googleAnalyticsTrackingId: 'UA-229205-42',
        googleAnalyticsTrackerName:
          'teal_seamlesslabs_UniversalstagingStandard',
        googleOptimizeContainerId: 'GTM-W3VGLRQ',
        friendBuyId: 'site-177d0ef0-www.seamless.com',
        brazeId: 'c8ca1ae4-6f71-445f-b6d5-3fe8d694d73a',
        captchaUrl: 'https://pp.seamless.com/captcha/verify?',
      },
      web: {
        clientId: 'beta_seamless_ayNyuFxxVQYefSAhFYCryvXBPQc',
      },
    },
  },
  rc: {
    grubhub: {
      common: {
        umamiUrl: 'https://rc.grubhub.com',
      },
    },
    seamless: {
      common: {
        umamiUrl: 'https://rc.seamless.com',
      },
    },
  },
  production: {
    common: {
      contentfulStaticUrl: 'https://cdn.contentful.com',
      contentfulStaticWebAccessToken:
        '7e613e401c036ef5bb8210010979ce8c3b73827f1269e42af34556063318f36c',
      applePayMerchantId: 'merchant.com.grubhub.diner.production',
      jjApiUrl: 'https://api-gtm.grubhub.com',
      itJJApiUrl: 'https://api-internal-tools-gtm.grubhub.com',
      ccIframeUrl: 'https://cc.grubhub.com/ghs-payments.js',
      clickstreamV2PostUrl: 'https://api-gtm.grubhub.com',
      contentfulEnvironment: 'master',
      contentfulAccessToken: 'f1b4ovcVG67aRRQB6o6GwN2AhjNcWyz_Y5JfFyzw_lY',
      contentfulFeatureToggleAccessToken:
        'NlowpviMrm0bSocxTKP0GaDwhI6bP6CWV04ICMnkZEw',
      assets: 'https://assets.grubhub.com',
      zopimId: '18460959-000c-48bf-8f9b-f34d6dfc116a',
      zopimAvailabilityUrl:
        'https://api-internal-tools-us-east-1.grubhub.com/carereporting/chat/available',
      tapingoTicketsUrl:
        'https://api-internal-tools-us-east-1.grubhub.com/care-metrics/tapingo/tickets',
      sentry: {
        dsn: 'https://fdca46de26b74a6bb0fe0fbd362f7a10@sentry.io/1525572',
        sampleRate: 0.5,
      },
      tealiumEnvironment: 'prod',
      brazeOptions: {
        enableLogging: false,
        minimumIntervalBetweenTriggerActionsInSeconds: 60,
        sessionTimeoutInSeconds: 1800,
        baseUrl: 'https://sdk.iad-01.braze.com/api/v3',
      },
      sensorId: 'O97ybH4J',
    },
    web: {
      robots: 'all',
    },
    grubhub: {
      common: {
        umamiUrl: 'https://www.grubhub.com',
        googleNonConvertingTrackingId: 'UA-309051-82',
        googleAnalyticsTrackingId: 'UA-309051-46',
        googleAnalyticsTrackerName:
          'teal_grubhublabs_UniversalproductionStandard',
        googleOptimizeContainerId: 'GTM-58CKX3J',
        friendBuyId: 'site-2500bb38-host',
        brazeId: '456f6687-7c17-4725-a9f3-7a851ca4b0b0',
        captchaUrl: 'https://www.grubhub.com/captcha/verify?',
      },
      ios: {
        clientId: 'ghipad_Adwycf2h1g5BAdWPn14Z61r2jsK4Mj1Uq8SFdliS',
      },
      android: {
        clientId: 'ghandroid_Ujtwar5s9e3RYiSNV31X41y2hsK6Kh1Uv7JDrkpS',
      },
      web: {
        clientId: 'beta_UmWlpstzQSFmocLy3h1UieYcVST',
      },
    },
    seamless: {
      common: {
        umamiUrl: 'https://www.seamless.com',
        googleNonConvertingTrackingId: 'UA-229205-51',
        googleAnalyticsTrackingId: 'UA-229205-41',
        googleAnalyticsTrackerName:
          'teal_seamlesslabs_UniversalproductionStandard',
        googleOptimizeContainerId: 'GTM-P9PDR7N',
        friendBuyId: 'site-177d0ef0-www.seamless.com',
        brazeId: '4fc2d6e8-f42a-4293-99f1-130fe2c8cabc',
        captchaUrl: 'https://www.seamless.com/captcha/verify?',
      },
      ios: {
        clientId: 'seamlessiphone_34bcd9af3b30687af96c',
      },
      android: {
        clientId: 'seamlessandroid_83e5b8cc02e322b65080',
      },
      web: {
        clientId: 'beta_seamless_ayNyuFxxVQYefSAhFYCryvXBPQc',
      },
    },
  },
};
module.exports = configuration;
